<template>
  <v-card class="provider-card" flat>
    <slot name="header"></slot>
    <v-card-text class="provider-card-text">
      <v-layout row justify-start>
        <avatar class="mr-4" :name="avatarString" :size="avatarSize" :borderSize="1" color="#222" borderColor="#dddddd" backgroundColor="transparent" />
        <v-layout column>
          <v-layout v-if="provider.type==='google'" column class="provider-info">
            <span class="name">{{name}}</span>
            <span class="phone">{{phone}}</span>
            <span class="email">{{provider.address.line1}}</span>
          </v-layout>
          <v-layout v-else column class="provider-info">
            <span class="name">{{providerTitle}}
            </span>
            <span class="phone">{{provider.type}}</span>
            <span class="phone">{{phone}}</span>
            <span class="email">{{address}}</span>
          </v-layout>
        </v-layout>
      </v-layout>
      <v-spacer></v-spacer>
      <slot name="removeProviderSlot"></slot>
    </v-card-text>
    <v-card-actions class="provider-actions">
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss" scoped>
$font: sans-serif;
$color: #1565c0;
$phone: #999;
$addr: #1565c0;
$background-gray: #eee;

.provider-card {
  border: 0.5px solid #eeeeee;
  .card__text {
    // min-height: 60px;
    padding-bottom: 0;
  }

  .input-group.input-group--selection-controls {
    color: $color !important;
  }
  .button-row {
    position: relative;
    left: -3px;
    margin-top: 24px;
  }
  .btn {
    left: -22px;
    &.invite {
      left: -20px;
    }
  }
  .provider-info {
    min-height: 56px;
    span {
      font-size: 14px;
      line-height: 22px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      position: relative;

      &.name {
        font-size: 18px;
        line-height: 30px;
        font-weight: 700px;
        color: #222;
        text-transform: capitalize;
      }
      &.credential {
        line-height: 30px;
        font-size: 18px;
        font-weight: 700px;
        color: $phone;
      }
      &.phone {
        color: $phone;
        top: 2px;
      }
      &.email {
        color: $color;
        top: 4px;
      }
      &.address {
        color: $addr;
        top: 4px;
      }
      &.pending {
        font-style: italic;
        color: $phone;
        top: 8px;
      }
    }
  }

  .provider-actions {
    padding-top: 20px;
    padding-left: 64px;
  }

  .btn-label {
    color: $phone;
    font-family: $font;
    font-size: 14px;
    color: $phone;
    &.btn::before {
      background-color: transparent !important;
    }
  }
}
</style>

<script>
import Avatar from '@/core/components/Avatar'

export default {
  name: 'OneProviderCard',
  components: {
    Avatar
  },
  props: {
    provider: {
      type: Object,
      default() {
        return {
          name: 'No provider',
          email: 'No email',
          phone: 'No phone',
          address: 'No address'
        }
      }
    },
    showRemove: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    actionLabel: {
      type: String,
      default: 'Invite'
    }
  },
  computed: {
    name() {
      const provider = this.provider
      if (provider && provider.npi && provider.name) {
        return provider.name.toLowerCase()
      }
      return ''
    },
    providerTitle() {
      const provider = this.provider
      if (provider.firstName) {
        return (
          provider.firstName +
          ' ' +
          provider.lastName +
          ' ' +
          provider.credentials
        )
      } else if (provider.organizationName) {
        return provider.organizationName
      } else if (provider.displayNameIndividual) {
        return provider.displayNameIndividual
      } else if (provider.coveredEntityName) {
        return provider.coveredEntityName
      }
      return 'Missing Provider Name'
    },
    phone() {
      return this.provider.phone
    },
    address() {
      const address = this.provider.address
      return (
        address.line1 +
        ' ' +
        address.line2 +
        ' ' +
        address.city +
        ', ' +
        address.state +
        ' ' +
        address.zip
      )
    },
    fax() {
      return this.provider.fax
    },
    avatarSize() {
      return 48
    },
    avatarString() {
      const provider = this.provider
      if (provider.npi) {
        if (provider.name) {
          return provider.name
        } else {
          return provider.first + ' ' + provider.last
        }
      }
      return ''
    }
  },
  methods: {
    onRemove() {
      this.$emit('remove')
    },
    onEdit() {
      this.$emit('edit')
    },
    onAction() {
      this.$emit('action')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/ProviderCard.vue